import axios from 'axios'
import Jsona from 'jsona/lib/Jsona'

import { NotificationCenterHeaderName } from '../../@paco/entities/NotificationCenter/NotificationCenter'
import { formatDate } from '../../@paco/helpers/date'
import { DateFormat } from '../../@paco/types/dateFormatTypes'

const withEventLogHeader = (eventLogTrackerData) => (
    eventLogTrackerData
        ? {
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        }
        : {}
)

const jsonApiDataFormatter = new Jsona()

export const getPlannedShifts = (includes = [], startDate = null, endDate = null) => axios.get(
    `${process.env.REACT_APP_API_URL}/me/shifts/planned`,
    {
        params: {
            include: includes.join(','),
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
        },
    },
)

export const getOpenShifts = (includes = [], startDate = null, endDate = null) => axios.get(
    `${process.env.REACT_APP_API_URL}/me/shifts/open`,
    {
        params: {
            include: includes.join(','),
            startDate: formatDate(startDate, DateFormat.apiDateTime),
            endDate: formatDate(endDate, DateFormat.apiDateTime),
        },
    },
)

export const offerShift = (shiftId, eventLogTrackerData) => axios.post(
    `${process.env.REACT_APP_API_URL}/me/shift/offer/${shiftId}`,
    undefined,
    withEventLogHeader(eventLogTrackerData),
)

export const cancelShiftOffer = (shift, eventLogTrackerData) => axios.delete(
    `${process.env.REACT_APP_API_URL}/me/shift/offer/${shift.id}`,
    withEventLogHeader(eventLogTrackerData),
)

export const registerShiftOffer = (shift, eventLogTrackerData) => axios.post(
    `${process.env.REACT_APP_API_URL}/me/shift/register-offer/${shift.id}`,
    undefined,
    withEventLogHeader(eventLogTrackerData),
)

export const unregisterShiftOffer = (shift, eventLogTrackerData) => axios.delete(
    `${process.env.REACT_APP_API_URL}/me/shift/register-offer/${shift.id}`,
    withEventLogHeader(eventLogTrackerData),
)

export const addCommentToShift = comment => axios.post(
    `${process.env.REACT_APP_API_URL}/me/comment`, jsonApiDataFormatter.serialize({
        stuff: comment,
        includeNames: ['shiftPlannings'],
    }),
)
